export const realtorData = {
    email: 'fabians@gmail.com',
    phone:'9 xxxxxxx'
  };